import React, { useState, useEffect } from "react";
import mySplit from "../images/mySplitTest1.png";
import mySplitMain from "../images/mySplit-bg(2).png";
import triangle from "../images/triangle-yellow.svg";
import AthleteLayout from "./common/AthleteLayout";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export const AthleteMySplit = () => {
  const DEFAULT_INTENSITY = 85;
  const PROGRAM_INTENSITY = 100;

  const marks = {
    70: "70",
    75: "75",
    80: "80",
    85: "85",
    90: "90",
    95: "95",
    100: "100",
  };

  //lets build the state data here
  const [sport, setSport] = useState("Basketball"); // build this logic later when it comes.
  const [event_pace, setEventPace] = useState("");
  const [goal_time, setGoalTime] = useState("");
  const [intensity, setIntensity] = useState(DEFAULT_INTENSITY); //this value will come from the slider once integrated.
  const [training_distance, setTrainingDistance] = useState("");
  const [actual_time, setActualTime] = useState("");

  const [target_time, setTargetTime] = useState("_");
  const [performance, setPerformance] = useState("0");

  const eventDropdown = [100, 200, 400];
  const [showEventOpen, setShowEventOpen] = useState(false);

  const distance100Dropdown = [
    30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 150, 180, 250,
  ];
  const distance200Dropdown = [60, 80, 120, 140, 150, 160, 180, 200, 250];
  const distance400Dropdown = [100, 150, 200, 250, 300, 350, 400, 450];

  const [distanceDropdown, setDistanceDropdown] = useState([]);
  const [showDistanceOpen, setShowDistanceOpen] = useState(false);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const roundToNearestPointFive = (num) => Math.round(num * 2) / 2;

  // Function to calculate target time (will add logic later)
  const calculateTargetTime = () => {
    //onsole.log("Calculating target time...");

    //const target_time = ((((goal_time/(event_pace/100))/(intensity/100))/100*training_distance)).toFixed(1);
    const target_time = (
      Math.ceil(
        (goal_time / (event_pace / 100) / (intensity / 100) / 100) *
          training_distance *
          10,
      ) / 10
    ).toFixed(1);

    //build logic for target time here //=(goalTime/(eventPace/100)/intensityLevel)/100*trainingDistance
    setTargetTime(target_time);

    // Placeholder logic - replace this with actual calculation later
  };

  useEffect(() => {
    if (event_pace > 0 && goal_time > 0 && training_distance > 0) {
      calculateTargetTime();
    }
  }, [intensity, event_pace, goal_time, training_distance]);

  const handleReset = async (e) => {
    e.preventDefault();

    setTargetTime("_");
    setPerformance("0");
    // Force state reset by setting to null first, then default value
    setIntensity(null);
    setTimeout(() => setIntensity(DEFAULT_INTENSITY), 0);

    setEventPace("");
    setGoalTime("");
    setTrainingDistance("");
    setActualTime("");
    setDistanceDropdown([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !sport ||
      !event_pace ||
      !goal_time ||
      !intensity ||
      !training_distance ||
      !actual_time
    ) {
      setError("Please enter all of the inputs");
      return;
    }

    setError(null);
    setLoading(true);

    const performance = Math.round(
      (200 / 100 -
        ((actual_time /
          ((goal_time / (event_pace / 100 / (PROGRAM_INTENSITY / 100)) / 100) *
            training_distance)) *
          100) /
          100) *
        100,
    );
    //build logic for performance here //200-(actualTime/((goalTime/(eventPace/100)/100)/100*trainingDistance)*100)
    setLoading(false);
    setPerformance(performance);

    /*  try {
          const response = await fetch(API_URL.POST_TOOLS_MYSPLIT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({sport,event_pace,goal_time,intensity,training_distance,actual_time}),
          });

          const json = await response.json();
          setLoading(false);

          if (response.ok) {
            setTargetTime(json.target_time);
            setPerformance(json.performance);
          } 
          else 
          {
            // Display error returned by the server
            setError(json.error || 'An error occurred. Please try again.');
          }
        } catch (err) {
          setLoading(false);
          setError('Failed to connect to the server. Please try again.');
        }
      */
  };

  return (
    <AthleteLayout>
      <div className="bg-[#e6e6e6] h-full !overflow-y-auto">
        <div className="h-auto w-full max-w-2xl mx-auto px-5 relative !overflow-y-auto">
          {/*<AthleteHeader />*/}
          <div className="relative z-[2]  py-10 mb-8 xs:mb-10">
            <p className="text-block text-2xl xs:text-3xl leading-none">
              MySplit.
            </p>
          </div>

          <div className="relative z-[2] text-center space-y-8 pt-3">
            <div>
              <p className="text-black text-5xl xs:text-[58px] leading-[90%] mb-2">
                {target_time}
              </p>
              <span className="text-grayish text-sm xs:text-base font-light !leading-[90%] capitalize pt-1.5">
                Target Time
              </span>
            </div>
            <div>
              <p className="text-black text-3xl xs:text-4xl font-light leading-[90%]">
                {performance}%
              </p>
              <span className="text-grayish text-xs xs:text-sm font-light !leading-[90%] capitalize">
                Performance
              </span>
            </div>
          </div>
          {/* slider here */}
          <div className="relative z-[2] my-5 px-5">
            <div className="pl-3">
              <p className="text-black text-base font-medium tracking-[-0.408px] !leading-none">
                {intensity}% Intensity
              </p>
            </div>
            <div
              style={{ padding: "10px", background: "#0000", color: "#fff" }}
            >
              <Slider
                allowCross={false}
                min={70}
                max={100}
                step={5}
                value={intensity}
                marks={marks}
                trackStyle={{
                  backgroundColor: "#c19e42",
                  height: 12,
                  borderRadius: 0,
                }}
                handleStyle={{
                  borderColor: "#fff",
                  opacity: "1",
                  height: 14,
                  width: 14,
                  backgroundColor: "#fff",
                  marginTop: -1,
                }}
                railStyle={{
                  backgroundColor: "#a9a9a9",
                  height: 12,
                  borderRadius: 0,
                }}
                dotStyle={{
                  borderColor: "white",
                  backgroundColor: "white",
                  borderRadius: "0px",
                  height: "6px",
                  width: "2px",
                }}
                activeDotStyle={{
                  borderColor: "red",
                }}
                style={{
                  marginBottom: "20px",
                }}
                onChange={(value) => setIntensity(value)}
              />
            </div>
          </div>
          {/* _________rgba(168, 168, 168, 1)_________ */}
          <div className="relative z-[2] flex flex-col gap-8">
            <div className="flex gap-y-3 bg-black rounded-2xl py-2 xs:px-3 xs:py-2">
              <div className="w-full xs:w-1/3 border-r border-white/70 p-2 xs:px-3 xs:py-2">
                <div
                  className="relative cursor-pointer flex flex-col justify-between gap-2 h-full"
                  onClick={() => setShowEventOpen(!showEventOpen)}
                >
                  <div className="flex flex-row justify-center items-center gap-2">
                    <p className="text-white text-xs xs:text-lg !leading-none font-medium capitalize">
                      Event
                    </p>
                    <img
                      src={triangle}
                      alt="icon"
                      className={`object-contain w-2 xs:w-3 ${
                        showEventOpen ? "rotate-180" : "rotate-0"
                      }`}
                    />
                  </div>

                  <div className="w-full text-center">
                    <span className="w-full text-white text-sm xs:text-xl font-light !leading-none">
                      {event_pace ? `/ ${event_pace}m` : ""}
                    </span>
                  </div>
                  {showEventOpen && (
                    <ul
                      className={`absolute top-full h-fit left-0 w-full min-w-full border  border-transparent focus:outline-none rounded-md bg-black mt-2 shadow-lg z-10 `}
                    >
                      {eventDropdown.map((option) => (
                        <li
                          key={option}
                          onClick={() => {
                            setEventPace(option);
                            setShowEventOpen(false);
                            if (option === 100) {
                              setDistanceDropdown(distance100Dropdown);
                            } else if (option === 200) {
                              setDistanceDropdown(distance200Dropdown);
                            } else if (option === 400) {
                              setDistanceDropdown(distance400Dropdown);
                            } else {
                              setDistanceDropdown([]);
                            }
                          }}
                          className="px-3 py-1 text-xs text-darkYellow hover:bg-[#e6e6e6] cursor-pointer rounded-sm overflow-hidden"
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="w-full xs:w-1/3 border-r border-white/70">
                <div className="p-2 xs:px-3 xs:py-2">
                  <p className="text-center text-white text-xs xs:text-lg !leading-none font-medium capitalize mb-2.5">
                    Goal Time
                  </p>
                  <div className="inline-block">
                    <input
                      type="text"
                      className="w-full text-white text-center text-base xs:text-xl font-light !leading-none border-b border-darkYellow bg-transparent placeholder:text-gray-400"
                      value={goal_time}
                      onChange={(element) => setGoalTime(element.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="w-full xs:w-1/3 p-2 xs:px-3 xs:py-2">
                <div
                  className="relative cursor-pointer flex flex-col justify-between gap-2 h-full"
                  onClick={() => setShowDistanceOpen(!showDistanceOpen)}
                >
                  <div className="flex flex-row justify-center items-center gap-2">
                    <p className="text-white text-xs xs:text-lg !leading-none font-medium capitalize">
                      Distance
                    </p>
                    <img
                      src={triangle}
                      alt="icon"
                      className={`object-contain w-2 xs:w-3 ${
                        showDistanceOpen ? "rotate-180" : "rotate-0"
                      }`}
                    />
                  </div>

                  <div className="text-center">
                    <span className="text-white text-base xs:text-xl font-light !leading-none">
                      {training_distance}
                    </span>
                  </div>

                  {showDistanceOpen && (
                    <ul
                      className={`absolute top-full h-fit right-0 w-full min-w-full border border-transparent focus:outline-none rounded-md bg-black text-white mt-2 shadow-lg z-10 max-h-[160px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-black pb-1`}
                    >
                      {" "}
                      {distanceDropdown.map((option) => (
                        <li
                          key={option}
                          onClick={() => {
                            setTrainingDistance(option);
                            setShowDistanceOpen(false);
                          }}
                          className="px-3 py-1 text-xs text-darkYellow hover:bg-[#e6e6e6] cursor-pointer rounded-sm overflow-hidden"
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-5 xs:gap-8">
                <div className="w-full">
                  <input
                    type="text"
                    className="w-full h-12 text-center bg-[#a8a8a8a6] border border-grayish/5 rounded-2xl text-black text-base !leading-none placeholder:text-black/80 p-3"
                    placeholder="Actual Time"
                    value={actual_time}
                    onChange={(element) => setActualTime(element.target.value)}
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  className="w-full h-12 bg-smock rounded-2xl p-3 text-center flex flex-col justify-center items-center hover:bg-grayish transition-all"
                >
                  <span className="bg-black w-[30px] h-px block mb-[14px]"></span>
                  <span className="bg-black w-[30px] h-px block"></span>
                </button>
                <button
                  onClick={handleReset}
                  className="w-full h-12 text-center p-3 text-white text-base leading-none bg-darkYellow hover:bg-yellow-600 rounded-2xl capitalize transition-all duration-300"
                >
                  reset
                </button>
              </div>
              {/* Display Error Message */}
              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            </div>

            {/* Display Loading Indicator */}
            {loading && (
              <p className="text-yellow-500 text-sm mt-2">
                Processing request please wait...
              </p>
            )}
          </div>

          <div className="absolute left-1/2 -translate-x-1/2 top-10 xs:top-10 w-full xs:min-w-72 max-w-[430px] xs:max-w-[90%] h-full z-0">
            <img
              src={mySplitMain}
              alt="mySplit"
              className="w-full xs:h-full object-contain"
            />
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};
